import { Logo } from '@/components/Header';
import { ArrowLeft } from 'lucide-react';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-stone-100">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 py-5 flex items-center justify-between">
          <Logo />
          <a href="/" className="flex items-center gap-2 text-sm text-stone-500 hover:text-stone-900 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            Back to home
          </a>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 lg:px-8 py-16">
        <h1 className="text-3xl sm:text-4xl font-bold text-stone-900 mb-2">Terms of Service</h1>
        <p className="text-sm text-stone-400 mb-12">Last updated: January 1, 2026</p>

        <div className="prose prose-stone max-w-none space-y-8 text-stone-600 leading-relaxed text-[15px]">
          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-3">1. Introduction</h2>
            <p>These Terms of Service ("Terms") govern your access to and use of the website and services provided by SalesWall AI ("we", "us", "our") at saleswall.ai. By accessing or using our services, you agree to be bound by these Terms. If you do not agree, please do not use our services.</p>
            <p>These Terms are governed by and comply with applicable EU regulations, including the GDPR, the Consumer Rights Directive 2011/83/EU, and the Unfair Commercial Practices Directive 2005/29/EC.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-3">2. Description of Services</h2>
            <p>SalesWall AI provides a pitch filtering and evaluation service for businesses. We intercept inbound sales activity directed at your organization, objectively evaluate each opportunity, and deliver curated reports of relevant opportunities.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-3">3. Eligibility</h2>
            <p>Our services are intended for business use. By using our services, you represent that you are at least 18 years of age and have the legal authority to enter into these Terms on behalf of yourself or the organization you represent.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-3">4. Waitlist Registration</h2>
            <p>By joining our waitlist, you provide your email address voluntarily. We will use this email solely to communicate about early access availability and product updates. You may unsubscribe at any time by contacting us at <a href="mailto:saleswall@saleswall.ai" className="text-violet-600 hover:text-violet-700 underline underline-offset-4">saleswall@saleswall.ai</a>.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-3">5. Intellectual Property</h2>
            <p>All content, trademarks, logos, and intellectual property displayed on saleswall.ai are the property of SalesWall AI or its licensors. You may not reproduce, distribute, modify, or create derivative works without our prior written consent.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-3">6. Limitation of Liability</h2>
            <p>To the maximum extent permitted by applicable EU law, SalesWall AI shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services. Nothing in these Terms excludes or limits liability for death, personal injury caused by negligence, fraud, or any other liability that cannot be excluded under EU law.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-3">7. Data Protection</h2>
            <p>We process your personal data in accordance with our <a href="/privacy" className="text-violet-600 hover:text-violet-700 underline underline-offset-4">Privacy Policy</a> and in compliance with the GDPR. You have the right to access, rectify, erase, restrict, and port your personal data as described in our Privacy Policy.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-3">8. Right of Withdrawal</h2>
            <p>If you are a consumer within the EU/EEA, you have the right to withdraw from any service agreement within 14 days without giving any reason, in accordance with the Consumer Rights Directive 2011/83/EU. To exercise this right, contact us at <a href="mailto:saleswall@saleswall.ai" className="text-violet-600 hover:text-violet-700 underline underline-offset-4">saleswall@saleswall.ai</a>.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-3">9. Modifications to Terms</h2>
            <p>We reserve the right to modify these Terms at any time. Material changes will be communicated via the email address you have provided. Continued use of our services after changes take effect constitutes acceptance of the revised Terms.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-3">10. Governing Law and Dispute Resolution</h2>
            <p>These Terms are governed by the laws of the European Union and the applicable member state where the user resides. Any disputes shall be subject to the exclusive jurisdiction of the competent courts in the user's member state of residence, in accordance with EU consumer protection regulations.</p>
            <p>For EU consumers, the European Commission provides an Online Dispute Resolution (ODR) platform at <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-violet-600 hover:text-violet-700 underline underline-offset-4">ec.europa.eu/consumers/odr</a>.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-3">11. Severability</h2>
            <p>If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions shall continue in full force and effect.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-stone-900 mb-3">12. Contact</h2>
            <p>For any questions regarding these Terms of Service, please contact us at:</p>
            <p className="bg-stone-50 rounded-lg p-4 border border-stone-100">
              <a href="mailto:saleswall@saleswall.ai" className="text-violet-600 hover:text-violet-700 underline underline-offset-4">saleswall@saleswall.ai</a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
